import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { Button } from './ui/button';
import { Clapperboard } from 'lucide-react';

const FIELDS = [
  { key: 'demo_video_url', ep: 'demo-video', label: 'Vidéo guide (accueil, « Comment ça marche »)', ph: 'Lien YouTube… (vide = vidéo guide générée)' },
  { key: 'tutorial_video_url', ep: 'tutorial-video', label: 'Vidéo espace vendeur (onglet Aide)', ph: 'Lien YouTube… (vide = vidéo guide générée)' },
];

export function VideoSettings() {
  const [v, setV] = useState({ demo_video_url: '', tutorial_video_url: '' });
  useEffect(() => { api.get('/settings/public').then(({ data }) => setV(data)).catch(() => {}); }, []);
  const save = async (f) => {
    try { await api.post(`/admin/settings/${f.ep}`, { url: v[f.key] || '' }); toast.success('Enregistré'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); }
  };
  return (
    <section className="card-elev rounded-2xl p-5" data-testid="video-settings">
      <h2 className="font-display text-xl font-bold flex items-center gap-2 mb-4"><Clapperboard className="h-5 w-5 text-sky-400" />Vidéos</h2>
      <div className="space-y-3">
        {FIELDS.map((f) => (
          <div key={f.key} className="grid sm:grid-cols-[1fr_auto] gap-2 items-end">
            <label className="text-sm text-slate-300">{f.label}
              <input data-testid={`${f.ep}-input`} value={v[f.key] || ''} onChange={(e) => setV({ ...v, [f.key]: e.target.value })} placeholder={f.ph}
                className="mt-1 w-full px-3 py-2 rounded-xl bg-slate-900 border border-slate-700 text-white outline-none text-sm" />
            </label>
            <Button data-testid={`${f.ep}-save`} onClick={() => save(f)} className="btn-brand text-white">Enregistrer</Button>
          </div>
        ))}
      </div>
    </section>
  );
}
